var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUmbrella = function SvgUmbrella(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 15,
    "data-width-24": 22,
    viewBox: "0 0 14.8 12.9",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M12.94 11.888 2.86 1.808a7.274 7.274 0 0 1 10.08 10.08"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M9.893 8.842c2.154-2.536 2.794-5.434 2.117-6.111S8.44 2.7 5.906 4.854M1.604 9.383.989 10a1.335 1.335 0 0 0 0 1.883 1.335 1.335 0 0 0 1.883 0l5.027-5.028"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUmbrella);
export default ForwardRef;